import * as Types from './action';

const initialState = {
    corporateList: [],
    corporateLoading: false,
    corporateError: null,

    productList: [],
    productLoading: false,
    productError: null,

    isDownloading: false,
    downloadSuccess: false,
    downloadError: null,

    uploadLoading: false,
    uploadError: null,
    uploadSuccessMessage: null,

    uploadListData: {},
    uploadListLoading: false,
    uploadListError: null,

    fileDownloadLoading: false,
    fileDownloadUrl: null,
    fileDownloadError: null,
};

export default function bulkCaseUpdationReducer(state = initialState, action) {
    switch (action.type) {
        case Types.FETCH_CORPORATE_AUTOCOMPLETE:
            return { ...state, corporateLoading: true, corporateError: null };

        case Types.FETCH_CORPORATE_AUTOCOMPLETE_SUCCESS:
            return {
                ...state,
                corporateList: action.data || [],
                corporateLoading: false,
            };

        case Types.FETCH_CORPORATE_AUTOCOMPLETE_FAILURE:
            return {
                ...state,
                corporateList: [],
                corporateLoading: false,
                corporateError: action.data,
            };

        case Types.FETCH_PRODUCTS_BY_CORPORATE:
            return { ...state, productLoading: true, productError: null };

        case Types.FETCH_PRODUCTS_BY_CORPORATE_SUCCESS: {
            const products = action.data?.data || action.data || [];
            return {
                ...state,
                productList: products.map(product => ({
                    value: product.id,
                    label: product.productName,
                    ...product,
                })),
                productLoading: false,
            };
        }

        case Types.FETCH_PRODUCTS_BY_CORPORATE_FAILURE:
            return {
                ...state,
                productList: [],
                productLoading: false,
                productError: action.error || 'Failed to populate product schemas',
            };

        case Types.DOWNLOAD_BULK_REPORT_EXCEL:
            return {
                ...state,
                isDownloading: true,
                downloadSuccess: false,
                downloadError: null,
            };

        case Types.DOWNLOAD_BULK_REPORT_EXCEL_SUCCESS:
            return {
                ...state,
                isDownloading: false,
                downloadSuccess: true,
                downloadError: null,
            };

        case Types.DOWNLOAD_BULK_REPORT_EXCEL_FAILURE:
            return {
                ...state,
                isDownloading: false,
                downloadSuccess: false,
                downloadError: action.error?.message || action.error || 'Failed to download spreadsheet',
            };

        case Types.UPDATE_BULK_CASES:
            return { ...state, uploadLoading: true, uploadError: null };

        case Types.UPDATE_BULK_CASES_SUCCESS:
            return {
                ...state,
                uploadLoading: false,
                uploadError: null,
                uploadSuccessMessage: action?.payload,
            };

        case Types.UPDATE_BULK_CASES_FAILURE:
            return {
                ...state,
                uploadLoading: false,
                uploadError: action.payload,
            };

        case Types.RESET_BULK_UPLOAD_STATE:
            return {
                ...state,
                uploadLoading: false,
                uploadError: null,
                uploadSuccessMessage: null,
            };

        case Types.FETCH_BULK_CASE_UPDATION_LIST:
            return { ...state, uploadListLoading: true, uploadListError: null };

        case Types.FETCH_BULK_CASE_UPDATION_LIST_SUCCESS:
            return {
                ...state,
                uploadListData: action.data || {},
                uploadListLoading: false,
            };

        case Types.FETCH_BULK_CASE_UPDATION_LIST_FAILURE:
            return {
                ...state,
                uploadListLoading: false,
                uploadListError: action.error,
            };

        case Types.DOWNLOAD_BULK_CASE_UPDATION_FILE:
            return {
                ...state,
                fileDownloadLoading: true,
                fileDownloadUrl: null,
                fileDownloadError: null,
            };

        case Types.DOWNLOAD_BULK_CASE_UPDATION_FILE_SUCCESS:
            return {
                ...state,
                fileDownloadLoading: false,
                fileDownloadUrl: action.payload,
                fileDownloadError: null,
            };

        case Types.DOWNLOAD_BULK_CASE_UPDATION_FILE_FAILURE:
            return {
                ...state,
                fileDownloadLoading: false,
                fileDownloadUrl: null,
                fileDownloadError: action.error?.data?.message || action.error?.message || action.error || 'Failed to download file',
            };

        default:
            return state;
    }
}
